import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { ActivatedRoute } from '@angular/router';
import { AccountService } from '../../services/account.service';
import { AuthService } from '../../services/auth.service';
import { OrganisationDashboardVM } from '../../models/OrganisationDashboardVM';

@Component({
  selector: 'home',
  templateUrl: './home.component.html'
})
export class HomeComponent extends BaseComponent implements OnInit {

  model: OrganisationDashboardVM = new OrganisationDashboardVM();

  constructor(
    private route: ActivatedRoute,
    private accService: AccountService,
    private authService: AuthService
  ) {
    super(route);
  }

  ngOnInit(): void {
    this.emitDisplayLoadingDialog(true);
    this.accService.getDashboard()
      .subscribe(
        result => this.model = result,
        error => {
          this.showDialog("Error loading information, please refresh page.", true);
          this.emitDisplayLoadingDialog(false);
          console.log(error);
        },
        () => { this.emitDisplayLoadingDialog(false); }
      );

    this.authService._whoAmI = null;
    this.authService.whoAmI(true).subscribe(
      result => this.me = result,
      error => {
        this.showDialog("Error loading information, please refresh page.", true);
        this.emitDisplayLoadingDialog(false);
        console.log(error);
      }
    );
  }
}
